import React from 'react'
import { Platform, View } from 'react-native'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { Provider as PaperProvider } from 'react-native-paper'
import { NavigationContainer } from '@react-navigation/native'
import { createStackNavigator } from '@react-navigation/stack'
import { BuildAChairApp } from './components/app'
import { Config } from './config'
import { Login } from './components/login'
import { configTable } from './config-table'
import { ecomConfig } from './sites/ecom/config'

const getPartnerWeb = () => {
  return (new URLSearchParams(window.location.search)).get('p')
}

const getAuthPartner = async () => {
  try {
    const value = await AsyncStorage.getItem('@auth_code')
    return value
  } catch(e) {
    console.log({e})
    return null
  }
}

const Stack = createStackNavigator()

export const Router = () => {
  const [routerConfig, setRouterConfig] = React.useState<Config | null>(null)
  const [appLoggedIn, setAppLoggedIn] = React.useState(false)

  React.useEffect(() => {
    init()
  }, [])

  const init = async () => {
    if (Platform.OS === 'web') {
      const partner = getPartnerWeb() ?? 'ecom'
      const config = configTable.get(partner) ?? ecomConfig

      setRouterConfig(config ?? null)
      setAppLoggedIn(false)
    } else {
      const partner = await getAuthPartner()
      if (partner !== null) {
        const config = configTable.get(partner)
        const loggedIn = partner !== null

        setRouterConfig(config ?? null)
        setAppLoggedIn(loggedIn)
      } else {
        setAppLoggedIn(false)
        setRouterConfig(null)
      }
    }
  }

  const onLogOut = () => {
    init()
  }

  const onLogin = (partner: string) => {
    init()
  }

  return (
    <NavigationContainer>
      <Stack.Navigator screenOptions={{headerShown: false}}>
        <Stack.Screen name={routerConfig?.displayName ?? 'Login'}>
        {
          (props) => (Platform.OS === 'web' || appLoggedIn) && routerConfig ? <PaperProvider><BuildAChairApp onLogOut={onLogOut} config={routerConfig} /></PaperProvider> : <Login login={onLogin} />
        }
        </Stack.Screen>
      </Stack.Navigator>
    </NavigationContainer>
  )
}